export default function ProblemSolution() {
  return (
    <section id="problem-solution" className="bg-white dark:bg-[#070D1B] overflow-hidden">
      {/* Top label */}
      <div className="max-w-7xl mx-auto px-8 lg:px-16 pt-28 pb-16">
        <span className="text-xs tracking-widest uppercase text-[#2563EB] font-medium">
          The Problem &amp; The Fix
        </span>
      </div>

      {/* Full-bleed two-panel block */}
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[540px]">
        {/* Problem — dark, cinematic */}
        <div className="relative bg-[#0B2A4A] overflow-hidden flex flex-col justify-end px-14 lg:px-20 py-16">
          <img
            src="https://public.readdy.ai/ai/img_res/1f915e2656e1b7d08a0765698d4a1a06.jpg"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B2A4A] via-[#0B2A4A]/80 to-transparent" />
          <div className="relative z-10">
            <div className="w-10 h-10 flex items-center justify-center mb-8">
              <i className="ri-alert-line text-white/30 text-2xl" />
            </div>
            <p className="text-xs text-white/35 tracking-widest uppercase mb-6 font-medium">
              The Problem
            </p>
            <h3 className="text-3xl lg:text-4xl font-medium text-white leading-[1.2] tracking-[-0.015em]">
              Most businesses lose<br />opportunities in the gaps—<br />missed calls, slow follow-ups,<br />disconnected systems.
            </h3>
          </div>
        </div>

        {/* Solution — clean, confident */}
        <div className="relative bg-[#F8FAFC] dark:bg-[#0C1322] overflow-hidden flex flex-col justify-end px-14 lg:px-20 py-16">
          <img
            src="https://readdy.ai/api/search-image?query=clean%20minimal%20bright%20abstract%20soft%20white%20light%20rays%20organized%20structured%20grid%20lines%20calm%20modern%20professional%20technology%20solution%20clarity%20concept&width=800&height=600&seq=henexa-solution-v2&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center opacity-30 dark:opacity-15"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F8FAFC] dark:from-[#0C1322] via-[#F8FAFC]/85 dark:via-[#0C1322]/85 to-transparent" />
          <div className="relative z-10">
            <div className="w-10 h-10 flex items-center justify-center mb-8">
              <i className="ri-check-double-line text-[#2563EB] text-2xl" />
            </div>
            <p className="text-xs text-[#0B2A4A]/60 dark:text-white/55 tracking-widest uppercase mb-6 font-medium">
              The Solution
            </p>
            <h3 className="text-3xl lg:text-4xl font-medium text-[#0B2A4A] dark:text-white leading-[1.2] tracking-[-0.015em]">
              Henexa AI replaces<br />fragmented processes with<br />structured systems that<br />move every lead forward.
            </h3>
          </div>
        </div>
      </div>

      {/* Bottom detail strip */}
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-10">
        <div className="flex items-center gap-4">
          <div className="h-px flex-1 bg-[#E5E7EB] dark:bg-white/10" />
          <span className="text-xs tracking-widest uppercase text-[#0B2A4A]/55 dark:text-white/40 font-medium whitespace-nowrap">
            Built for operational clarity
          </span>
          <div className="h-px flex-1 bg-[#E5E7EB] dark:bg-white/10" />
        </div>
      </div>
    </section>
  );
}
